module.exports = __webpack_public_path__ + "static/media/icon-conversions.5a6dc4f2.svg";